import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export type Sticker = {
    text: string,
    settings: {
        fontSize: string,
        colorTheme: { // color theme elm
            color: string,
            backgroundColor: string,
        },
    }
}

@Component({
    selector: 'app-sticker',
    standalone: true,
    imports: [],
    templateUrl: './sticker.component.html',
    styleUrl: './sticker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StickerComponent {
    text: string;
    @HostBinding('class') fontSize: string;
    @HostBinding('style.--color') color: string;
    @HostBinding('style.--background-color') backgroundColor: string;

    @Input() set sticker(sticker: Sticker) {
        this.text = sticker?.text;
        this.fontSize = sticker?.settings?.fontSize ?? 'size-16';
        this.color = sticker?.settings?.colorTheme?.color;
        this.backgroundColor = sticker?.settings?.colorTheme?.backgroundColor;
    }
}
